import React from 'react';
import { Link } from 'react-router';
import { TextArea, Input, DropDown, TextMessage} from 'components/tt-forms/common';
import { Dialog } from "@blueprintjs/core";
import { ThanhTra } from 'api';
import {
  DropDownChonDonViChuTriThanhTra
} from 'components/tt-forms';

class DialogChinhSuaCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        doiTuongThanhTraInfo: {},
        noiDungThanhTra: '',
        donViChuTriInfo: {
          coQuanQuanLyId: '',
          ten: ''
        },
        donViPhoiHop: '',
        kyThanhTra: '',
        linhVucThanhTraInfo: {
          text: '',
          type: ''
        },
        thoiHanThanhTra:''
      },
      linhVucList: [],
      dataDonViChuTri: [],
      danhSachDonViPhoiHop: [],
      donViPhoiHop: ''
    }
  }

  componentDidMount() {
    this.getLinhVuc();
    this.getDonViChuTri();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      let arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(',') : [];
      let danhSachDonViPhoiHop = [];
      arrDv.map(item => {
        danhSachDonViPhoiHop.push({ten: item});
        return item
      });
      this.setState({
        data: nextProps.data,
        danhSachDonViPhoiHop: danhSachDonViPhoiHop
      })
    }
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViChuTri: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getLinhVuc() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({linhVucList: res.data});
      } else {
        this.setState({linhVucList: []});
      }

    })
  }

  addDonVi(arr, value, e) {
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten === this.state[value]
    })

    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        let newItem = {
          ten: this.state[value]
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    return;
  }

  removeDonVi(arr, index) {
    let newData = [...this.state[arr]];
    newData.splice(index, 1);
    this.setState({
      [arr]: newData
    });
  }

  handleSave() {
    this.state.dataDonViChuTri.map(item => {
      if (item.coQuanQuanLyId === this.state.data.donViChuTriInfo.coQuanQuanLyId) {
        this.setState({
          data:{donViChuTriInfo:{ten: item.ten}}
        })
      }
      return item.coQuanQuanLyId
    });
    this.state.linhVucList.map(item => {
      if (item.giaTri === this.state.data.linhVucThanhTraInfo.type) {
        this.setState({
          data:{linhVucThanhTraInfo:{text: item.ten}}
        })
      }
      return item.giaTri
    });
    let listDV = [];
    this.state.danhSachDonViPhoiHop.map(item => {
      listDV.push(item.ten);
      return item.ten
    });
    this.setState({
      data:{donViPhoiHop: listDV.join(', ')}
    })
    this.props.onSave(this.state.data);
    this.props.onClose();
  }

  onChange(name, e) {
    if (name === 'linhVucThanhTra') {
      this.setState({
        data:{linhVucThanhTraInfo:{type: e.target.value}}
      })
    } else if (name === 'phamViThanhTra') {
      this.setState({
        data:{kyThanhTra: e.target.value}
      })
    } else if (name === 'thoiHanThanhTra') {
      this.setState({
        data:{thoiHanThanhTra: e.target.value}
      })
    } else if (name === 'noiDungThanhTra') {
      this.setState({
        data:{noiDungThanhTra: e.target.value}
      })
    } else if (name === 'donViChuTri') {
      this.setState({
        data:{donViChuTriInfo:{coQuanQuanLyId: e.target.value}}
      })
    } else {
      this.setState({
        [name] : e.target.value
      })
    }
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        title='Chỉnh sửa cuộc thanh tra'
        className="dialog-them-moi-dttt dialog-default wrap-block"
      >
        <div className='row pl30 pr30'>
          <div className='col-100'>
            <h2 className='title-14 pt20 pb15'>1. Đối tượng thanh tra</h2>
          </div>
          <TextMessage label='Tên đối tượng:' className='col-40' value={this.state.data.doiTuongThanhTraInfo.ten || ''}/>
          <TextMessage label='Loại đối tượng:' className='col-20' value={this.state.data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : ''}/>
          <TextMessage label='Địa chỉ:' className='col-40' value={this.state.data.doiTuongThanhTraInfo.diaChi || ''}/>
          <TextMessage label='Ngành/Lĩnh vực:' className='col-100 mt10' value={this.state.data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo.ten : ''}/>
          <TextMessage label='Ghi chú:' className='col-100 mt10' value={this.state.data.doiTuongThanhTraInfo.ghiChu || ''}/>
        </div>
        <div className="row pl15 pr15"><span className="big-border mt10 mb20"></span></div>
        <div className='row pl30 pr30'>
          <div className='col-100'>
            <h2 className='title-14 pb15'>2. Thông tin cuộc thanh tra/kiểm tra</h2>
          </div>
          <DropDown className='col-25' label='Lĩnh vực thanh tra' selectedValue={this.state.data.linhVucThanhTraInfo.type} onChange={this.onChange.bind(this, 'linhVucThanhTra')} name='linhVucThanhTra' placeholder
              options={this.state.linhVucList} keyName="giaTri" valueName="ten" require/>
          <Input label="Thời kỳ thanh tra" value={this.state.data.kyThanhTra} onChange={this.onChange.bind(this, 'phamViThanhTra')} name='phamViThanhTra' className="col-25" maxLength={255}/>
          <Input label="Thời hạn làm việc (ngày)" value={this.state.data.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')} name='thoiHanThanhTra' className="col-25"/>
          <TextArea className='col-100' label='Nội dung thanh tra' value={this.state.data.noiDungThanhTra} onChange={this.onChange.bind(this, 'noiDungThanhTra')} name='noiDungThanhTra' rows={3} placeholder='Nhập...' maxLength={500}/>
          {/* <DropDownChonDonViChuTriThanhTra label='Đơn vị chủ trì' className='col-25' data={this.state.dataDonViChuTri} selectedValue={this.state.data.donViChuTriInfo.coQuanQuanLyId} onChange={this.onChange.bind(this, 'donViChuTri')} name='donViChuTri'/> */}
          {/* <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViPhoiHop', 'donViPhoiHop')}>
            <div className='wrap-input-tt-dvph col-25'>
              <Input label='Đơn vị phối hợp' placeholder='Nhập...' className='col-100 no-gutter' value={this.state.donViPhoiHop} onChange={this.onChange.bind(this, 'donViPhoiHop')} name='donViPhoiHop'/>
              <button className='btn-add-dvph' type='submit'></button>
            </div>
            <div className='col-75 mb18'>
              <div className='ds-tt-dvph'>
                {
                  this.state.danhSachDonViPhoiHop.map((item,i) => {
                    return (
                      <div className='tt-dvph-item' key={i}>
                        <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViPhoiHop', i)}>×</span>
                        <span className="tt-dvph-value">{item.ten}</span>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </form> */}
        </div>
        <div className='row pl15 pr15'>
          <span className='line-border mt5 mb0'></span>
        </div>
        <div className="action-form-wrap pt20">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={ this.props.onClose }><span>Đóng</span></Link>
            <Link className="btn-action btn-save" onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
          </div>
        </div>
      </Dialog>
    );
  }
}

DialogChinhSuaCuocThanhTra.defaultProps = {
  data: {}
}

export default DialogChinhSuaCuocThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DialogChinhSuaCuocThanhTra.jsx